import { projectApi } from "@/api/projectApi";
import Breadcrumbs from "@/components/Breadcrumbs";
import Loading from "@/components/feedback/Loading";
import { Box, Button, Container, Tab, Tabs, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { Outlet, Link as RouterLink, useSearchParams } from "react-router-dom";

const CURRENT_PAGE_KEY = "page";
const PAGE_SIZE_KEY = "per_page";

const defaultSearchParams = {
    [CURRENT_PAGE_KEY]: 1,
    [PAGE_SIZE_KEY]: 15,
};

export default function ProjectFinderLayout() {
    const [searchParams, setSearchParams] = useSearchParams(defaultSearchParams);
    const [projectFilter, setProjectFilter] = useState({
        [CURRENT_PAGE_KEY]: searchParams.get(CURRENT_PAGE_KEY),
        [PAGE_SIZE_KEY]: searchParams.get(PAGE_SIZE_KEY),
    });
    const [getProjectsTrigger, projectsResult] = projectApi.endpoints.getAllProjects.useLazyQuery();
    const isLoading = projectsResult.isLoading || projectsResult.isFetching;

    useEffect(() => {
        getProjectsTrigger(projectFilter);
    }, [projectFilter]);

    return (
        <>
            <Container>
                <Breadcrumbs items={[{ label: "Projects", to: "/workspace/projects" }]} />
            </Container>
            <Container>
                <Box sx={{ display: "flex", flexDirection: "row" }}>
                    <Box>
                        <Typography variant="h1" fontSize={34} fontWeight="bold" gutterBottom>
                            Projects
                        </Typography>
                    </Box>
                    <Box sx={{ marginLeft: "auto" }}>
                        <Button disabled={true} sx={{ textTransform: "none" }}>
                            Search
                        </Button>
                        <Button
                            component={RouterLink}
                            variant="contained"
                            color="primary"
                            to="/projects/new"
                            sx={{ textTransform: "none" }}
                        >
                            New Project
                        </Button>
                    </Box>
                </Box>
                <Tabs value={0} sx={{ borderBottom: 1, borderColor: "divider" }}>
                    <Tab
                        label="All"
                        value={0}
                        // sx={{ textTransform: "none", display: "inline-flex" }}
                    />
                </Tabs>
            </Container>
            <Container sx={{ marginY: 1 }}>total: {projectsResult.data?.data?.length ?? "-"}</Container>
            {isLoading ? <Loading /> : <Outlet context={{ projects: projectsResult }} />}
        </>
    );
}
